export default __webpack_public_path__ + "static/media/gt1.518952fe.png";